(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/javascripts/prescript.js');

'use strict';

svs.playerRegistration = svs.playerRegistration || {};
svs.playerRegistration.shared = svs.playerRegistration.shared || {};
svs.playerRegistration.service = svs.playerRegistration.service || {};
svs.playerRegistration.components = svs.playerRegistration.components || {};
svs.playerRegistration.store = svs.playerRegistration.store || {};

svs.playerRegistration.pages = svs.playerRegistration.pages || {};
svs.playerRegistration.pages.register = svs.playerRegistration.pages.register || {};
svs.playerRegistration.pages.depositLimits = svs.playerRegistration.pages.depositLimits || {};
svs.playerRegistration.pages.kyc = svs.playerRegistration.pages.kyc || {};
svs.playerRegistration.pages.deposit = svs.playerRegistration.pages.deposit || {};
svs.playerRegistration.pages.rejected = svs.playerRegistration.pages.rejected || {};
svs.playerRegistration.pages.accountCreated = svs.playerRegistration.pages.accountCreated || {};

svs.playerRegistration.logger = new svs.core.log.Logger('module:player-registration');


 })(window);